export const decodeB64 = (text) => {
  return text ? window.atob(text) : "";
};
